export default __webpack_public_path__ + "static/media/logo-dark.3a5510b8.png";